import { Organ } from './entities'

export enum Roles {
  user = 'GENERADOR',
  admin = 'ADMIN'
}

export interface IdpInfo {
  ine10: string
  ensActiu: string
  urlEacat: string
  urlCsv: string
  organismes: Array<Organ>
  organismesAutocomplete: Array<string>
  nomIdp: string
  nomEnsActiu: string
  ensDisponibles: Array<{ ens: string; nom: string; color: string }>
  rol: string
  nom: string
  colorEnsActiu?: string
  impersonated?: boolean
}
